import React, { useState } from "react";
// import useInputHook from "../hooks/useInputHook";
import { Link } from "../MyWork/style";
import { Container, Title, Wrapper, Icons, Input, Text, Button, Form, ErrorMessage } from "./style";
import Success from "./SuccessMessage";
export default function Contact(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  const setUserName = (e) => {
    if (e.target.value.trim().length > 0) {
      setIsNameValid(true);
    }
    setName(e.target.value);
  };
  const setUserEmail = (e) => {
    if (e.target.value.trim().length > 0) {
      setIsEmailValid(true);
    }
    setEmail(e.target.value);
  };
  const setUserMessage = (e) => {
    if (e.target.value.trim().length > 0) {
      setIsMessageValid(true);
    }
    setMessage(e.target.value);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (name.trim().length === 0 && email.trim().length === 0 && message.trim().length === 0) {
      setIsNameValid(false);
      setIsEmailValid(false);
      setIsMessageValid(false);

      // setIsSubmitted(true);
      return;
    } else if (
      name.trim().length !== 0 &&
      email.trim().length !== 0 &&
      message.trim().length !== 0
    ) {
      setName("");
      setEmail("");
      setMessage("");
      setTimeout(() => {
        setIsSuccess(true);
      }, 1000);
    }
    const userData = {
      userName: name,
      userEmail: email,
      userMessage: message,
    };
    console.log(userData);
  };

  const resetModal = () => {
    setIsSuccess(false);
  };

  const errorMessageName = !isNameValid && <ErrorMessage>please enter your name</ErrorMessage>;
  const errorMessageEmail = !isEmailValid && <ErrorMessage>please enter your email</ErrorMessage>;
  const errorMessageMessage = !isMessageValid && <ErrorMessage>please fill the blank</ErrorMessage>;
  // const success = !isSubmitted ? <RequestSubmitted>hi</RequestSubmitted> : "";

  return (
    <div style={{ width: "100%" }}>
      {isSuccess && (
        <Success
          resetModal={resetModal}
          title="Request Submitted"
          message="Thank you for submitting!"
        />
      )}
      <Container>
        <Container title reveal>
          <Title title main>
            Contact Me
          </Title>
          <Title range />
          <Wrapper content>
            <Wrapper row>
              <Wrapper card reveal>
                <Wrapper icon>
                  <Icons.Map />
                </Wrapper>
                <Wrapper info>
                  <Title title>Address</Title>
                  <Title info>San Francisco, CA, USA</Title>
                </Wrapper>
              </Wrapper>
              <Wrapper card reveal>
                <Wrapper icon>
                  <Icons.Phone />
                </Wrapper>
                <Wrapper info>
                  <Title title>Phone</Title>
                  <Title info>San Francisco, CA, USA</Title>
                </Wrapper>
              </Wrapper>
              <Wrapper card reveal>
                <Wrapper icon>
                  <Icons.EnvelopeFill />
                </Wrapper>
                <Link href="mailto:sardor4ik2013@gmail.com">
                  <Wrapper info>
                    <Title title>Email</Title>
                    <Title info>sardor4ik2013@gmail.com</Title>
                  </Wrapper>
                </Link>
              </Wrapper>
              <Wrapper card reveal>
                <Wrapper icon>
                  <Icons.Globe />
                </Wrapper>
                <Link href="https://sardorbek.urspace.io/" target="blank">
                  <Wrapper info>
                    <Title title>Website</Title>
                    <Title info>San Francisco, CA, USA</Title>
                  </Wrapper>
                </Link>
              </Wrapper>
            </Wrapper>
            <Wrapper row>
              <Form onSubmit={submitHandler} contactForm reveal>
                <Title contact>Send Message</Title>
                <Wrapper input>
                  <Input
                    isValid={isNameValid}
                    onChange={setUserName}
                    value={name}
                    placeholder="Name"
                  />
                  {errorMessageName}
                </Wrapper>
                <Wrapper input>
                  <Input
                    isValid={isEmailValid}
                    onChange={setUserEmail}
                    value={email}
                    placeholder="Email"
                    // required
                    type="email"
                  />
                  {errorMessageEmail}
                </Wrapper>
                <Text
                  isValid={isMessageValid}
                  onChange={setUserMessage}
                  value={message}
                  cols="80"
                  rows="8"
                  placeholder="Messages"
                />
                {errorMessageMessage}
                <Button type="submit">Send</Button>
              </Form>
            </Wrapper>
          </Wrapper>
        </Container>
      </Container>
    </div>
  );
}
